import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/theme-variables.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initResponsiveTableObserver } from './utils/responsiveTableHelper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Enable automatic card-view data-labels for all tables on mobile and tablet
initResponsiveTableObserver();

// Register service worker for Progressive Web App capabilities
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
    }
  }
});


